module.exports = __webpack_public_path__ + "img/camco-finance-logo.21a8087e.png";